<template>
    <div>

        <template v-if="transporterDetail">
            <!--<Row>{{transporterDetail.name}} (<span :style="{color: getColor(transporterDetail.status)}">{{transporterDetail.status}}</span>)</Row>-->
            <Row :gutter="10" style="font-size: 15px">
                <Col :md="8">
                    <Row :gutter="10">
                        <Col :md="8" style="color: #444444">Name</Col><Col span="1">:</Col>
                        <Col :md="12">{{transporterDetail.name}}</Col>
                        <Col :md="8" style="color: #444444">Mobile No.</Col><Col span="1">:</Col>
                        <Col :md="12">{{transporterDetail.mobile}}</Col>
                        <Col :md="8" style="color: #444444">Email</Col><Col span="1">:</Col>
                        <Col :md="12">{{transporterDetail.email}}</Col>
                        <Col :md="8" style="color: #444444">Address</Col><Col span="1">:</Col>
                        <Col :md="12">{{getCompanyDetailString(transporterDetail.address[0])}}</Col>
                    </Row>
                </Col>
                <Col :md="8">
                    <Row :gutter="10">
                        <Col :md="8" style="color: #444444">GST</Col><Col span="1">:</Col>
                        <Col :md="12">{{transporterDetail.gstin?transporterDetail.gstin:'-'}}</Col>
                        <Col :md="8" style="color: #444444">PAN</Col><Col span="1">:</Col>
                        <Col :md="12">-</Col>
                        <Col :md="8" style="color: #444444">City</Col><Col span="1">:</Col>
                        <Col :md="12">{{transporterDetail.address[0].city}}</Col>
                        <Col :md="8" style="color: #444444">Total Trucks</Col><Col span="1">:</Col>
                        <Col :md="12">{{transporterDetail.trucks.length}}</Col>
                        <Col :md="8" style="color: #444444">Total Drivers</Col><Col span="1">:</Col>
                        <Col :md="12">{{transporterDetail.drivers.length}}</Col>
                    </Row>
                </Col>
                <Col :md="8">
                    <Row :gutter="10">
                        <Col :md="8" style="color: #444444">Total Orders</Col><Col span="1">:</Col>
                        <Col :md="12">{{orders.length}}</Col>
                        <Col :md="8" style="color: #444444">Total Billing Amt</Col><Col span="1">:</Col>
                        <Col :md="12">-</Col>
                        <Col :md="8" style="color: #444444">Total Paid Amt</Col><Col span="1">:</Col>
                        <Col :md="12">-</Col>
                        <Col :md="8" style="color: #444444">Due Amt</Col><Col span="1">:</Col>
                        <Col :md="12">-</Col>
                        <Col :md="8" style="color: #444444">Status</Col><Col span="1">:</Col>
                        <Col :md="12">
                          <i-switch v-model="transporterDetail.isApproved" @on-change="onChangeStatus(transporterDetail)" :style="transporterDetail.isApproved?'background: green':'background: red'"/>
                          <!-- <Tag color="success" v-if="transporterDetail.isApproved">Active</Tag>
                          <Tag color="error" v-else-if="transporterDetail.isRejected">InActive</Tag>
                          <Tag color="warning" v-else>Pending</Tag> -->
                        </Col>
                    </Row>
                </Col>
            </Row>
        </template>


        <Tabs v-model="screen" type="card" style="margin-top: 50px">
            <TabPane label="Details" name="details"></TabPane>
            <TabPane label="Order Details" name="order_details"></TabPane>
            <TabPane label="Truck Orders" name="truck_orders"></TabPane>
        </Tabs>

        <div v-show="screen === 'details'">
            <Row :gutter="10">
                <Col :md="12">
                  <Button icon="md-add" @click="openDetailForm('addCompanyUserDrawer')">Add User</Button>
                  <Button v-if="isAdmin" @click="exportTransporterSubTable('companyUsers','action')" style="float: right; text-align: end">Export CSV</Button>
                  <hot-table :settings="companyUsers_hotSettings" ref="companyUsers_hotTableComponent" style="margin: 20px 0 0 0">
                    <hot-column v-for="(colset, index) in companyUsers_columns" :settings="colset" :key="index">
                    </hot-column>
                  </hot-table>
                </Col>
                <Col :md="12">
                    <Button icon="md-add" @click="openDetailForm('addContactDrawer')">Add Contact</Button>
                    <Button v-if="isAdmin" @click="exportTransporterSubTable('contacts','action')" style="float: right; text-align: end">Export CSV</Button>
                    <hot-table :settings="contacts_hotSettings" ref="contacts_hotTableComponent" style="margin: 20px 0 0 0">
                        <hot-column v-for="(colset, index) in contacts_columns" :settings="colset" :key="index">
                        </hot-column>
                    </hot-table>
                </Col>
                <Col :md="12" style="margin-top: 10px">
                    <Button icon="md-add" @click="openDetailForm('addAddressDrawer')">Add Address</Button>
                    <Button v-if="isAdmin" @click="exportTransporterSubTable('addresses','action')" style="float: right; text-align: end">Export CSV</Button>
                    <hot-table :settings="addresses_hotSettings" ref="addresses_hotTableComponent" style="margin: 10px 0 0 0">
                        <hot-column v-for="(colset, index) in addresses_columns" :settings="colset" :key="index">
                        </hot-column>
                    </hot-table>
                </Col>
              <Col :md="12" style="margin-top: 10px;">
                    <Button icon="md-add" @click="onAddRoute">Add Route</Button>
                    <hot-table :settings="routes_hotSettings" ref="routes_hotTableComponent" style="margin: 10px 0 0 0;">
                        <hot-column v-for="(colset, index) in routes_columns" :settings="colset" :key="index"/>
                    </hot-table>
                </Col>
            </Row>
            <Row :gutter="10">
                <Col :md="12">
                    <Button @click.stop="onAddTruck()" style="margin-top: 10px">Add Truck</Button>
                    <Button v-if="isAdmin" @click="exportTransporterSubTable('trucks','action')" style="float: right;margin-top: 10px">Export CSV</Button>
                    <hot-table :settings="trucks_hotSettings" ref="trucks_hotTableComponent" style="margin: 10px 0 0 0">
                        <hot-column v-for="(colset, index) in trucks_columns" :settings="colset" :key="index">
                        </hot-column>
                    </hot-table>
                </Col>
                <Col :md="12">
                    <Button @click.stop="onAddDriver()" style="margin-top: 10px">Add Driver</Button>
                    <Button v-if="isAdmin" @click="exportTransporterSubTable('drivers','action')" style="float: right; margin-top: 10px">Export CSV</Button>
                    <hot-table :settings="drivers_hotSettings" ref="drivers_hotTableComponent" style="margin: 10px 0 0 0">
                        <hot-column v-for="(colset, index) in drivers_columns" :settings="colset" :key="index">
                        </hot-column>
                    </hot-table>
                </Col>
            </Row>
        </div>

        <div v-show="screen === 'order_details'">
            <Spin fix size="small" v-if="!this.$route.params.id"></Spin>
            <Row>
                <Col :md="8">
                    <DatePicker v-model="filterDate" type="daterange" :options="dateOptions" placeholder="Select date" :clearable="false"
                                format="dd/MM/yyyy" class="filterInput" @on-change="onChangeDate"></DatePicker>
                </Col>
                <Input @on-keydown="debounceInput" id="search-field" placeholder="Search by party, order no, LR etc" style="width: 300px; float: right;"/>
            </Row>
            <Row style="margin-top: 5px">
              <Button v-if="isAdmin" @click="exportTransporterSubTable('orders')" style="float: right; text-align: end">Export CSV</Button>
            </Row>
            <hot-table :settings="orders_hotSettings" ref="orders_hotTableComponent" style="margin: 10px 0 0 0">
                <hot-column v-for="(colset, index) in orders_columns" :settings="colset" :key="index">
                </hot-column>
            </hot-table>
        </div>
        <div v-show="screen === 'truck_orders'">
            <Spin fix size="small" v-if="!this.$route.params.id"></Spin>
            <Row>
                <Col :md="8">
                    <DatePicker v-model="filterDate_truckOrders" type="daterange" :options="dateOptions" placeholder="Select date" :clearable="false"
                                format="dd/MM/yyyy" class="filterInput" @on-change="onChangeDate_truckOrders"></DatePicker>
                </Col>
              <Button v-if="isAdmin" @click="exportTransporterSubTable('truckOrders')" style="float: right;">Export CSV</Button>
            </Row>

            <hot-table :settings="truckOrders_hotSettings" ref="truckOrders_hotTableComponent" style="margin: 20px 0 0 0">
                <hot-column v-for="(colset, index) in truckOrders_columns" :settings="colset" :key="index">
                </hot-column>
            </hot-table>
        </div>

      <Modal v-model="routeDialog" :mask-closable="false" width="450" draggable>
        <div slot="header"><strong>{{selectedRouteIndex?'Edit':'Add'}} Route</strong></div>
        <div>
          <AutoComplete v-model="routes_fromCity" style="width: 45%;margin:0 10px 5px 0" @on-search="handleCitySearch" @on-focus="routeCityFilter='%%'" placement="top">
          <Option v-for="(cityObj,index) in cityArr" :label="cityObj.city" :key="index" :value="cityObj.city">
            <div class="ivu-select-item-div">{{cityObj.city}}</div>
          </Option>
          </AutoComplete>
          <AutoComplete v-model="routes_toCity" style="width: 45%;margin:0 5px 5px 0" @on-search="handleCitySearch" @on-focus="routeCityFilter='%%'" placement="top">
            <Option v-for="(cityObj,index) in cityArr" :label="cityObj.city" :key="index" :value="cityObj.city">
              <div class="ivu-select-item-div">{{cityObj.city}}</div>
            </Option>
          </AutoComplete>
        </div>
        <div slot="footer">
          <Button type="primary" style="font-weight: bolder" @click="updateTransporterRoute">SAVE</Button>
          <Button style="background: #999999; color: white;font-weight: bolder" @click="routeDialog=false">CANCEL</Button>
        </div>
      </Modal>

        <manage-order :orderId="orderId" ref="manage-order-page" :viewPath="viewPath"></manage-order>
        <update-detail ref="update-detail-form"></update-detail>
        <driver ref="driver-comp" isLoadedIn="transporters"></driver>
        <truck ref="truck-comp"></truck>
    </div>
</template>

<script>
    import { HotTable, HotColumn } from '@handsontable/vue'
    import Handsontable from 'handsontable'
    import {GET_TRANSPORTER_DETAIL} from "../../graphql/queries/companies"
    import {
      SUBSCRIBE_CONTACTS_BY_COMPANY_ID,
      SUBSCRIBE_ORDERS_BY_COMPANY_ID,
      SUBSCRIBE_TRANSPORTER_DETAIL, SUBSCRIBE_USERS_BY_COMPANY_ID
    } from "../../graphql/subscription/companies"
    import {SUBSCRIBE_TRUCK_ORDERS_BY_TRANSPORTER_ID} from "../../graphql/subscription/truckOrders"
    import moment from 'moment'
    import {Constants} from '../../Constants/Constant'
    import {calculateTotalWeightOfOrders} from "../ExcelTruckOrders/Settings"
    import {orderPriorityColors, dateOptions, generateHotSettings, nestedHeaders} from "../ExcelFormattedOrders/Settings"
    import {truckOrderNumRenderer, weightRenderer} from "../ExcelTruckOrders/RendererFunctions"
    import ManageOrder from "../Manage Order/ManageOrder"
    import _ from 'lodash'
    import UpdateDetail from "../ExcelClients/UpdateDetail";
    import {actionRenderer, statusRenderer} from "../ExcelContractors/RendererFunctions";
    import Driver from "../Settings/Driver";
    import Truck from "../Settings/Truck";
    import {getAddressString} from "../ExcelFormattedOrders/RendererFunctions";
    import {SEARCH_CITY2} from "../../graphql/queries/territories";
    import {generate_UPDATE_ORDER_DATA} from "../../graphql/mutations/orders";

    export default {
        name: "TransporterDetail",
        components: {Truck, Driver, UpdateDetail, ManageOrder, HotTable, HotColumn },
        provide() {
            return {
                getManageOrderDrawer: () => this.manageOrderDrawer,
                setManageOrderDrawer: (data) => { this.manageOrderDrawer = data },
                getOrder: () => this.order,
                closeAssignVehicleDialog: (data) => { },
            }
        },
        apollo: {
            $subscribe: {
                orders: {
                    query: SUBSCRIBE_ORDERS_BY_COMPANY_ID,
                    skip () {return !this.$route.params.id},
                    variables() {
                        return {
                            companyId: this.$route.params.id,
                            startDate: this.startDate,
                            endDate: this.endDate,
                            stageFilter: null,
                            materialType: {},
                            searchFilter: '%' + this.globalSearch + '%',
                            lrName: { lrName: this.globalSearch },
                            pickupCity: {"address":[]},
                            dropCity: {"address":[]},
                        }
                    },
                    result ({ data }) {
                        this.orders = data.orders
                        this.prepareSheetDataForOrders(data.orders)
                        this.prepareArrayThenEvaluateWt(data.orders)
                    },
                },
                truckOrders: {
                    query: SUBSCRIBE_TRUCK_ORDERS_BY_TRANSPORTER_ID,
                    skip () {return !this.$route.params.id},
                    variables() {
                        return {
                            transporterId: this.$route.params.id,
                            startDate: this.startDate_truckOrders,
                            endDate: this.endDate_truckOrders
                        }
                    },
                    result ({ data }) {
                        this.truckOrders = data.truckOrders
                        this.prepareSheetDataForTruckOrders(data.truckOrders)
                    },
                },
                transporterDetail: {
                    query: SUBSCRIBE_TRANSPORTER_DETAIL,
                    skip () {return !this.$route.params.id},
                    variables() {
                      return {
                        companyId: this.$route.params.id
                      }
                    },
                    result ({ data }) {
                        this.transporterDetail = data.transporterDetail[0]
                        this.prepareSheetDataForAddresses(data.transporterDetail[0].address)
                        this.prepareSheetDataForRoutes(data.transporterDetail[0].routes || [])
                        this.prepareSheetDataForTrucks(data.transporterDetail[0].trucks)
                        this.prepareSheetDataForDrivers(data.transporterDetail[0].drivers)
                        this.trucks = data.transporterDetail[0].trucks;
                        this.drivers = data.transporterDetail[0].drivers;
                        this.addresses = data.transporterDetail[0].address;
                        this.routes = data.transporterDetail[0].routes || [];
                    }
                  },
                contacts: {
                    query: SUBSCRIBE_CONTACTS_BY_COMPANY_ID,
                    skip () {return !this.$route.params.id},
                    variables() {
                      return {
                        companyId: this.$route.params.id
                      }
                    },
                    result ({ data }) {
                      this.contacts = data.contacts;
                      this.prepareSheetDataForContacts(data.contacts)
                    },
                },
                users: {
                    query: SUBSCRIBE_USERS_BY_COMPANY_ID,
                    skip () {return !this.$route.params.id},
                    variables() {
                      return {
                        companyId: this.$route.params.id
                      }
                    },
                    result ({ data }) {
                      this.companyUsers = data.users;
                      this.prepareSheetDataForCompanyUsers(data.users)
                    }
                },
                city: {
                  query: SEARCH_CITY2,
                  variables() { return { cityFilter: this.routeCityFilter }},
                  result ({ data, loading }) {
                    if (!loading) { this.cityArr = data.city }
                  }
                },
            }
        },
        data: function () {
            return{
                Constants: Constants,
                screen: 'details',
                transporterDetail: null,
                orders: [],
                truckOrders: [],
                totalWtOfOrders: 0,
                changeStatusPopup: false,
                loader1: false,
                errMessages: [],
                manageOrderDrawer: false,
                orderId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                currentOrderStatus: '',
                order: '',
                viewPath: '',
                globalSearch: '',
                filterDate: [moment().subtract(30, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
                startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),
                filterDate_truckOrders: [moment().subtract(30, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
                startDate_truckOrders: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                endDate_truckOrders: moment().format('YYYY-MM-DD'),
                dateOptions: dateOptions,
                contacts_columns: [
                    //table_key_intermediate
                    {
                        title: 'Person<br> Name',
                        data: 'name',
                    },
                    {
                        title: 'Mobile',
                        data: 'mobile',
                    },
                    {
                        title: 'Type',
                        data: 'type',
                    },
                    {
                      title:'Action',
                      data: 'action',
                      renderer: (...args) => actionRenderer(...args, this, 'contacts', 'onEditContact', 'onDeleteContact')
                    }
                ],
                contacts_hotSettings: generateHotSettings([145, 100, 100, 100], nestedHeaders.contactsTable),
                companyUsers_columns: [
                  //table_key_intermediate
                  {
                    title: 'Name',
                    data: 'name',
                  },
                  {
                    title: 'Mobile',
                    data: 'mobile',
                  },
                  {
                    title: 'Email',
                    data: 'email',
                  },
                  {
                    title:'Action',
                    data: 'action',
                    renderer: (...args) => actionRenderer(...args, this, 'companyUsers', 'onEditCompanyUser', 'onDeleteCompanyUser')
                  }
                ],
                companyUsers_hotSettings: generateHotSettings([145, 100, 180, 100], nestedHeaders.companyUsersTable),
                addresses_columns: [
                    //table_key_intermediate
                    {
                        title: 'SR No.',
                        data: 'serialNum',
                    },
                    {
                        title: 'Address',
                        data: 'address',
                    },
                    {
                      title:'Action',
                      data: 'action',
                      renderer: (...args) => actionRenderer(...args, this, 'addresses', 'onEditAddress', 'onDeleteAddress')
                    }
                ],
                addresses_hotSettings: generateHotSettings([70, 400], nestedHeaders.addressesTable),
                trucks_columns: [
                    //table_key_intermediate
                    {
                        title: 'Truck<br>Number',
                        data: 'truckNumber',
                    },
                    {
                        title: 'capacity',
                        data: 'capacity',
                    },
                    {
                      title:'Action',
                      data: 'action',
                      renderer: (...args) => actionRenderer(...args, this, 'trucks', 'onEditTruck', 'onDeleteTruck')
                    }
                ],
                trucks_hotSettings: generateHotSettings([145, 100, 100], nestedHeaders.trucksTable),
                routes_columns: [
                    //table_key_intermediate
                    {
                        title: 'From City',
                        data: 'fromCity',
                    },
                    {
                        title: 'To City',
                        data: 'toCity',
                    },
                    {
                      title:'Action',
                      data: 'action',
                      renderer: (...args) => actionRenderer(...args, this, 'routes', 'onEditRoute', 'onDeleteRoute')
                    }
                ],
                routes_hotSettings: generateHotSettings([100, 100, 100], nestedHeaders.routesTable),
                drivers_columns: [
                    //table_key_intermediate
                    {
                        title: 'Name',
                        data: 'name',
                    },
                    {
                        title: 'Mobile',
                        data: 'mobile',
                    },
                    {
                        title: 'Type',
                        data: 'type',
                    },
                    {
                      title: 'Status',
                      data: 'status',
                      renderer: statusRenderer
                    },
                    {
                      title:'Action',
                      data: 'action',
                      renderer: (...args) => actionRenderer(...args, this, 'drivers', 'onEditDriver', 'onDeleteDriver')
                    }
                ],
                drivers_hotSettings: generateHotSettings([120, 100, 100, 100], nestedHeaders.driversTable),
                truckOrders_columns: [
                    //table_key_intermediate
                    {
                        title: 'Booking<br> Date',
                        data: 'bookingDate',
                        type: 'date',
                        dateFormat: 'DD/MM/YYYY'
                    },
                    {
                        title: 'Truck Order<br> Number',
                        data: 'truckOrderNumber',
                        renderer: truckOrderNumRenderer
                    },
                    {
                        title:'Status',
                        data: 'internalstatus'
                    },
                    {
                        title:'Rought',
                        data: 'rought'
                    },
                    {
                        title:'Truck<br> Number',
                        data: 'truckPlateNum'
                    },
                    {
                        title:'Transporter',
                        data: 'transporter'
                    },
                    {
                        title:'Driver',
                        data: 'driver'
                    },
                    {
                        title:'Eway Bill No.',
                        data: 'truckOrders_ewayBillNo'
                    },
                    {
                        title:'No of<br> Orders',
                        data: 'numOfOrders',
                        type: 'numeric'
                    },
                    {
                        title:'Total/<br>Committed<br>Wt(Kg)',
                        data: 'commitedWeight',
                        type: 'numeric',
                        renderer: weightRenderer
                    },
                    {
                        title:'Rate<br> (per ton)',
                        data: 'rate',
                        type: 'numeric'
                    },
                    {
                        title:'LR<br> Comm',
                        data: 'lrCommision',
                        type: 'numeric'
                    },
                    {
                        title:'Approx<br> Payment',
                        data: 'payment',
                        type: 'numeric',
                        numericFormat: { pattern: '0,00'}
                    },
                    {
                        title:'Order<br>Status',
                        data: 'status'
                    },
                ],
                truckOrders_hotSettings: generateHotSettings([110, 170, 145, 145, 100, 145, 140, 130, 90, 120, 100, 90, 100, 100]),
                orders_columns: [
                    //table_key_intermediate
                    {
                        title: 'Created On',
                        data: 'createdAt',
                        type: 'date',
                        dateFormat: 'DD MMM \'YY hh:mm A'
                    },
                    {
                        title: 'Updated On',
                        data: 'updatedAt',
                        type: 'date',
                        dateFormat: 'DD MMM \'YY hh:mm A'
                    },
                    {
                        title: 'Pickup<br> Date',
                        data: 'orders_pickupDate',
                        type: 'date', dateFormat: 'DD/MM/YYYY'
                    },
                    {
                        title: 'ERP Order No',
                        data: 'orderNumber',
                        renderer: this.orderNumberRenderer
                    },
                    {
                        title:'Status',
                        data: 'internalStatus',
                    },
                    {
                        title:'Comment',
                        data: 'comment',
                    },
                    {
                        title:'LR No.',
                        data: 'orderDetails_lrName_lrObject',
                    },
                    {
                        title:'Client Name',
                        data: 'clientName',
                    },
                    {
                        title:'Pickup Point',
                        data: 'pickupPartyName',
                    },
                    {
                        title:'Drop Point',
                        data: 'dropPartyName',
                    },
                    {
                        title:'Company',
                        data: 'companyName',
                    },
                    {
                        title:'Total<br> Weight',
                        data: 'kg',
                        type: 'numeric'
                    },
                    {
                        title:'Order<br> Details',
                        data: 'boxes'
                    },
                    {
                        title:'Eway Bill No',
                        data: 'orderDetails_ewayBillNo',
                    }
                ],
                orders_hotSettings: generateHotSettings([120, 120, 110, 145, 145, 180, 100, 145, 145, 145, 145, 100, 100, 130]),
                confirmDialog: false,
                confirmObj: {},
                updateRecord_loader: false,
                contacts: [],
                companyUsers: [],
                drivers: [],
                trucks: [],
                addresses: [],
                routes: [],
                routeDialog: false,
                selectedRouteIndex: null,
                cityArr: [],
                routes_fromCity: '',
                routes_toCity: '',
                routeCityFilter: '%%',
            }
        },
        computed: {
          isAdmin: function(){
            return this.$store.state.userObj.role[0].id === Constants.adminRoleId
          }
        },
        methods:{
            debounceInput: _.debounce(function (e) {
                this.globalSearch = e.target.value
            }, 500),
            onChangeDate(evt){
                this.startDate = moment(evt[0], 'DD/MM/YYYY').format('YYYY-MM-DD')
                this.endDate = moment(evt[1], 'DD/MM/YYYY').format('YYYY-MM-DD')
            },
            onChangeDate_truckOrders(evt){
                this.startDate_truckOrders = moment(evt[0], 'DD/MM/YYYY').format('YYYY-MM-DD')
                this.endDate_truckOrders = moment(evt[1], 'DD/MM/YYYY').format('YYYY-MM-DD')
            },
            handleCitySearch: _.debounce(function(val){
              this.routeCityFilter = '%' + val + '%'
            }, 500),
            prepareSheetDataForContacts(data){
                let mainArr = []
                data.forEach(curnt => {
                    curnt.obj = {
                        name: curnt.name,
                        mobile: curnt.mobile,
                        type: curnt.role === 1?'Marketing':'Dispatch',
                        action: ''
                    }
                    mainArr.push(curnt.obj)
                })
                this.contacts_hotSettings.data = mainArr
            },
            prepareSheetDataForAddresses(data){
                let mainArr = []
                data.forEach((curnt, index) => {
                    curnt.obj = {
                        serialNum: index+1,
                        address: this.getCompanyDetailString(curnt),
                        action: ''
                    }
                    mainArr.push(curnt.obj)
                })
                this.addresses_hotSettings.data = mainArr
            },
            prepareSheetDataForRoutes(data){
                let mainArr = []
                data.forEach((curnt, index) => {
                    curnt.obj = {
                        fromCity: curnt.fromCity,
                        toCity: curnt.toCity,
                        action: ''
                    }
                    mainArr.push(curnt.obj)
                })
                this.routes_hotSettings.data = mainArr
            },
            prepareSheetDataForTrucks(data){
                let mainArr = []
                data.forEach(curnt => {
                    curnt.obj = {
                        truckNumber: curnt.platNo,
                        capacity: curnt.capacity,
                        action: ''
                    }
                    mainArr.push(curnt.obj)
                })
                this.trucks_hotSettings.data = mainArr
            },
            prepareSheetDataForDrivers(data){
                let mainArr = []
                data.forEach(curnt => {
                    curnt.obj = {
                        name: curnt.name,
                        mobile: curnt.mobile,
                        type: curnt.driverType === 1?'Tempo Driver':'Truck Driver',
                        status: curnt.status,
                        action: ''
                    }
                    mainArr.push(curnt.obj)
                })
                this.drivers_hotSettings.data = mainArr
            },
            prepareSheetDataForCompanyUsers(data){
              let mainArr = []
              data.forEach(curnt => {
                curnt.obj = {
                  name: curnt.name,
                  mobile: curnt.mobile,
                  email: curnt.email,
                  action: ''
                  // type: curnt.role === 1?'Marketing':'Dispatch'
                }
                mainArr.push(curnt.obj)
              })
              this.companyUsers_hotSettings.data = mainArr
            },
            prepareSheetDataForTruckOrders(data){
                let mainArr = []
                data.forEach(curnt => {
                    curnt.obj = {
                        bookingDate: moment(curnt.bookingDate, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                        truckOrderNumber: curnt.truckOrderNumber,
                        internalStatusId: curnt.InternalStatus?curnt.InternalStatus.id:'',
                        rought: curnt.fromCity+ '-' + curnt.toCity,
                        truckPlateNum: curnt.truck.platNo,
                        transporter: curnt.Transporter.name,
                        driver: curnt.driverDetail.name,
                        truckOrders_ewayBillNo: curnt.ewayBillNo,
                        numOfOrders: curnt.orderDetailsArr.length,
                        commitedWeight: curnt.commitedWeight,
                        fromCity: curnt.fromCity,
                        toCity: curnt.toCity,
                        rate: curnt.price,
                        lrCommision: curnt.lrCommision,
                        payment: (curnt.commitedWeight*curnt.price/1000)-curnt.lrCommision,
                        truckOrders_status: curnt.status,
                        orderDetailsArr: curnt.orderDetailsArr,
                        truckOrderId: curnt.id,
                        internalstatus: curnt.InternalStatus?curnt.InternalStatus.name:'',
                        status: curnt.status
                    }
                    mainArr.push(curnt.obj)
                })
                this.truckOrders_hotSettings.data = mainArr
            },
            orderNumberRenderer(instance, td, row, col, prop, value, cellProperties) {
                Handsontable.renderers.TextRenderer.apply(this, arguments);
                let priority = instance.getDataAtRowProp(row, 'priority')                               //prop name 'priority'

                td.innerHTML = value.substring(0, 9) + '<p>' + value.substring(9, value.length) + '</p>'

                if(orderPriorityColors[priority]){
                    td.style.color = orderPriorityColors[priority]
                }
                td.classList.add('order-num-txt')
                let pRow = instance.toPhysicalRow(row)                               //When accessing original array
                let order = this.orders[pRow]
                let self = this
                td.onclick = function() {
                    self.editOrder(order)
                }
            },
            editOrder(order){
                this.orderId = order.id;
                this.viewPath = order.internalStatus.viewPath;      //Load form based on internalStatus.viewPath
                this.order = order;
                this.currentOrderStatus = order.internalStatus.id;
                this.manageOrderDrawer = true;
            },
            prepareSheetDataForOrders(data){
                let mainArr = []
                data.forEach(curnt => {
                    curnt.obj = {
                        createdAt: moment(curnt.createdAt).format('DD MMM \'YY hh:mm A'),
                        updatedAt: moment(curnt.updated_at).format('DD MMM \'YY hh:mm A'),
                        orders_pickupDate: moment(curnt.pickupDate, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                        orderNumber: curnt.orderNumber,
                        internalStatus: curnt.internalStatus.name,
                        comment: curnt.notes.length?curnt.notes[0].note:'',
                        clientName: curnt.clientobject.name,
                        pickupPartyName: curnt.orderDetails&&curnt.orderDetails.pickupPoint&&curnt.orderDetails.pickupPoint.pickupPartyId?
                            curnt.orderDetails.pickupPoint.pickupPartyName:curnt.pickuppartyobject.name,
                        dropPartyName: curnt.orderDetails&&curnt.orderDetails.dropPoint&&curnt.orderDetails.dropPoint.dropPartyId?
                            curnt.orderDetails.dropPoint.dropPartyName:curnt.droppingpartyobject.name,
                        companyName: curnt.pickuppartyobject.name,
                        kg: curnt.materials.kg,
                        boxes: curnt.materials.boxes,
                        orders_note: curnt.note?curnt.note:'-',
                        orderDetails_lrName_lrObject: curnt.orderDetails&&curnt.orderDetails.lrObject?curnt.orderDetails.lrObject.lrName:'',
                        orderDetails_ewayBillNo: curnt.orderDetails&&curnt.orderDetails.ewayBillNo?curnt.orderDetails.ewayBillNo:'-',
                        priority: curnt.priority,
                        internalStatusId: curnt.internalstatus,
                        unlink: 'unlink'
                    }
                    mainArr.push(curnt.obj)
                })
                this.orders_hotSettings.data = mainArr
            },
            prepareArrayThenEvaluateWt(arr){
                arr = arr.map((obj) => {return {order: obj}})
                this.totalWtOfOrders = calculateTotalWeightOfOrders(arr)
            },
            getCompanyDetailString(a){
                let str = ''
                // let a = obj.address[0]
                if(a.add1) str = str + a.add1 + ', '
                if(a.add2) str = str + a.add2 + ', '
                if(a.area) str = str + a.area + ', '
                if(a.city) str = str + a.city + ', '
                if(a.state) str = str + a.state
                if(a.pincode) str = str + ' - ' + a.pincode
                return str
            },
            openDetailForm(drawer){
              this.$refs['update-detail-form'][drawer] = true;
              if(drawer === 'addAddressDrawer'){ this.$refs['update-detail-form']['addressArr'] = this.addresses; }
            },
            onEditCompanyUser(user){
              this.$refs['update-detail-form'].onEditCompanyUser(user);
            },
            onDeleteCompanyUser(userId){
              this.$refs['update-detail-form'].onDeleteCompanyUser(userId);
            },
            onEditContact(contact){
              this.$refs['update-detail-form'].onEditContact(contact);
            },
            onDeleteContact(contactId){
              this.$refs['update-detail-form'].onDeleteContact(contactId);
            },
            onAddDriver(){
              let row = { id:this.transporterDetail.id, name: this.transporterDetail.name };
              this.$refs['driver-comp'].onAddDriver(row)
            },
            onEditDriver(row){
              row['Transporter'] = { id:this.transporterDetail.id, name: this.transporterDetail.name };
              this.$refs['driver-comp'].onEditDriver(row)
            },
            onDeleteDriver(driverId){
              this.$refs['driver-comp'].onDeleteDriver(driverId)
            },
            onAddTruck(){
              let row = { id:this.transporterDetail.id, name: this.transporterDetail.name };
              this.$refs['truck-comp'].onAddTruck(row)
            },
            onEditTruck(row){
              row['company'] = { id:this.transporterDetail.id, name: this.transporterDetail.name };
              this.$refs['truck-comp'].onEditTruck(row)
            },
            onDeleteTruck(truckId){
              this.$refs['truck-comp'].onDeleteTruck(truckId)
            },
            onAddRoute(){
              this.routes_fromCity = this.routes_toCity = ''
              this.selectedRouteIndex = null
              this.routeDialog = true
            },
            onEditRoute(data, index){
              this.routes_fromCity = this.routes[index].fromCity
              this.routes_toCity = this.routes[index].toCity
              this.selectedRouteIndex = index
              this.routeDialog = true
            },
            onDeleteRoute(routeId, index){
              this.$Modal.confirm({
                title: 'Confirmation',
                content: '<p>Are You sure want to delete Route ?</p>',
                onOk: () => {
                  this.routes.splice(index, 1)
                  let obj = {routes: this.routes}
                  this.updateRecord(this.$route.params.id, obj, 'company', this.$Modal)
                }
              });
            },
            updateTransporterRoute(){
              if(this.selectedRouteIndex === null) this.routes.push({fromCity: this.routes_fromCity, toCity: this.routes_toCity})
              else this.routes[this.selectedRouteIndex] = {fromCity: this.routes_fromCity, toCity: this.routes_toCity}
              let obj = {routes: this.routes}
              this.updateRecord(this.$route.params.id, obj, 'company')
              this.routeDialog = false
            },
            onEditAddress(data, index){
              this.$refs['update-detail-form'].onEditAddress(data, index);
              this.$refs['update-detail-form']['addressArr'] = this.addresses;
            },
            onDeleteAddress(addressId, index){
              console.log(addressId, index);
              this.$refs['update-detail-form'].onDeleteAddress(addressId, index);
              this.$refs['update-detail-form']['addressArr'] = this.addresses;
            },
            onChangeStatus(row){
              this.$Modal.confirm({
                title: 'Confirmation',
                content: '<p>Are You sure want to change status of Transporter ?</p>',
                loading: true,
                onOk: () => {
                  let obj = {isApproved: row.isApproved, isRejected: !row.isApproved}
                  this.updateRecord(row.id, obj, 'company', this.$Modal)
                },
                onCancel: () => {
                  row.isApproved = !row.isApproved
                }
              });
            },
            async updateRecord(id, obj, table, callback){
              let response = await this.$apollo.mutate({
                mutation: generate_UPDATE_ORDER_DATA(table),
                variables: { id: id, obj: obj}
              })
              if(response.data){
                this.$Message.success('Transporter updated successfully!')
                callback?.remove();
              }
            },
            modifyStringThenExport(str, table){
              let json = {
                'Transporter Name': this.transporterDetail.name,
                'Mobile No.': this.transporterDetail.mobile,
                'Email': this.transporterDetail.email,
                'Address': getAddressString(this.transporterDetail.address[0]),
                'GST': this.transporterDetail.gstin?this.transporterDetail.gstin:'-',
                'PAN': '-',
                'City': this.transporterDetail.address[0].city,
                'Status': this.transporterDetail.isApproved?'Active':'InActive',
                'Total Trucks': this.trucks.length,
                'Total Drivers': this.drivers.length,
                'Total Orders': this.orders.length,
                'Total Billing Amt': '',
                'Total Paid Amt': '',
                'Due Amt': ''
              }
              str = str.replace(/<\/?[^>]+(>|$)/g,"") + '\n\n';        //Remove html tags if any
              Object.keys(json).forEach((key) => {
                str = str + key + ',' + json[key] + '\n';
              });

              let blob = new Blob([str], {type: 'text/plain'});
              const a = window.document.createElement('a');
              a.href = window.URL.createObjectURL(blob);
              a.download = table + '_' + moment().format('DD_MMM_YYYY_HH_mm') +'.csv';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            },
            exportTransporterSubTable(table, prop){
              let hotInstance = this.$refs[table + '_hotTableComponent'].hotInstance;
              let endRow = hotInstance.countRows();
              let endColumn = prop ? (hotInstance.propToCol(prop) - 1) : hotInstance.countCols();
              let exportPlugin = hotInstance.getPlugin('exportFile');
              let str = exportPlugin.exportAsString('csv', {columnHeaders: true, range:[0, 0, endRow, endColumn]});
              this.modifyStringThenExport(str, 'Transporter'+table);
            },
        },
        mounted(){}
    }
</script>

<style scoped>
    /deep/  .ivu-spin-fix {
        top: 43px;
        left: 16px;
        z-index: 8;
        width: 86vw;
        height: 40vh;
    }
    /deep/ .handsontable > .ht_master{
        font-size: 14px;
    }
    /deep/ .handsontable > .ht_master > .wtHolder{
        /*width: 100% !important;*/
        width: unset !important;
        height: unset !important;
    }
    /deep/ .handsontable span.colHeader {
        font-size: 13px;
    }
    /deep/.handsontable td{
        vertical-align: middle !important;
        padding: 0 1px 0 1px !important;
        white-space: unset !important;
        font-size: 13px;
    }

    /deep/.handsontable th{
        background-color: #d9d9d9;
        color: #222;
        text-align: center;
        font-weight: 600;
        vertical-align: middle !important;
        white-space: nowrap !important;
        padding: 0 0px 0 0px !important;
    }
    .filterInput{
        width: 80%;
    }
    /deep/ .ivu-date-picker-cells  {
        font-size: 12px !important;
    }
    /deep/ .ivu-picker-panel-sidebar  {
        width:125px !important;
        margin-left:-116px !important;
    }
    .refresh-icon{
        float: right;
        margin: 9px 16px;
        font-size: 14px;
        cursor: pointer;
    }
</style>
<style>
    .order-num-txt:hover {
        text-decoration: underline;
    }
    .truck-order-num-txt:hover {
        text-decoration: underline;
    }
    .action-edit{
      font-size: 12px;
      color:grey;
      margin-right:15px;
      cursor: pointer;
    }
    .action-delete{
      font-size: 12px;
      color:red;
      cursor: pointer;
    }
    .action-delete:hover{
      color: #FF8C00;
    }
    .action-edit:hover{
      color: #c0c0c0;
    }
</style>
<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>
